<template>


  <div>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <!--          Operator-->
        <v-combobox
            v-model="item.operator"
            :items="enabledOperatorSelectItems"
            :error-messages="OperatorErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('order.operator')"
            item-text="login"
            item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <!--          Priority-->
        <v-combobox
            v-if="prioritySelectItems"
            v-model="item.priority"
            :items="prioritySelectItems"
            :error-messages="priorityErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('priority.priority')"
            item-text="name"
            item-value="@id"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <!--            End of production date-->
        <InputDate
            align="center"
            v-model="item.delivery"
            :label="$t('order.delivery_interne')"
            :errormessages="deliveryErrors"
        />
      </v-col>
    </v-row>
  </div>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
import has from "lodash/has";
import {validationMixin} from "vuelidate";
import InputDate from "@/components/InputDate.vue";
import {required} from "vuelidate/lib/validators";


export default {
  name: 'PopupStateToPrint',
  mixins: [validationMixin],

  components: {
    InputDate
  },

  props: {
    values: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    this.operatorGetSelectItems();
    this.priorityGetSelectItems();
  },

  data() {
    return {
      operator: null,
      priority: null,
    }
  },

  computed: {
    isLoading() {
      return (
          this.isLoading_priority ||
          this.isLoading_operator
      );
    },

    ...mapFields('priority', {
      prioritySelectItems: 'selectItems',
      isLoading_priority : 'isLoading'
    }),
    ...mapFields('user', {
      operatorSelectItems: 'selectItems',
      isLoading_operator : 'isLoading'
    }),

    item() {
      return this.initialValues || this.values ;
    },


    priorityErrors() {
      const errors = [];
      if (!this.$v.item.priority.$dirty) return errors;
      has(this.violations, 'priority') && errors.push(this.violations.priority);
      !this.$v.item.priority.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    deliveryErrors() {
      const errors = [];
      if (!this.$v.item.delivery.$dirty) return errors;
      has(this.violations, 'delivery') && errors.push(this.violations.delivery);
      !this.$v.item.delivery.daterequired && errors.push(this.$t('global.field_required'));
      return errors;
    },
    OperatorErrors() {
      const errors = [];

      if (!this.$v.item.operator.$dirty) return errors;

      has(this.violations, 'operator') && errors.push(this.violations.operator);

      !this.$v.item.operator.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    violations() {
      return this.errors || {};
    },
    enabledOperatorSelectItems() {
            if (this.operatorSelectItems) {
                return this.operatorSelectItems.filter(item => item.enabled && !item.supervision);
            }
            return [];
        },
  },

  methods: {
    ...mapActions({
      priorityGetSelectItems: 'priority/fetchSelectItems',
      operatorGetSelectItems: 'user/fetchSelectItems',
    }),
  },


  validations: {
    item: {
      priority: {
        required,
      },
      comment: {
      },
      operator: {
        required,
      },
      delivery: {
        required,
      },
    }
  }
}
</script>

